// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"470":"5e5fe2e3","607":"aea4b785","771":"2550d082","898":"1539b097","963":"6f6ae53a"}[chunkId] + ".chunk.js";
};